export const environment = {
  version: '678d677e2ffe162c8dd98456d8ca555c41cf1ee2',
  buildDate: '202610301313',
  environment: 'develop',
  production: false,
  debug: true,
  dash0Enabled: true,
  baseUrl: 'https://develop.jobboard.catch-talents.dev',
  apiBaseUrl: 'https://develop.api.catch-talents.dev',
  apiBaseUrlFallback: 'https://develop.api.catch-talents.dev',
  googleClientId:
    '691717356112-hcccatjr7pt1o2srjb1pq2c79nu6trgm.apps.googleusercontent.com',
  friendlyCaptchaV2SiteKey: 'FCMPE7D6EN3BAEGN',
};
